import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/links";
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  tone?: "dark" | "light";
  className?: string;
};
export function CTAButton({
  label,
  note,
  id,
  tone = "light",
  className = ""
}: CTAButtonProps) {
  return <div className={`flex w-full flex-col items-center gap-3 ${className}`} data-id="element-29" data-mp="2fys6umpqy3k0">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-gold px-5 py-5 text-center font-display text-[1.35rem] font-extrabold uppercase leading-[1.1] tracking-wide text-navy-950 shadow-cta transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-light active:translate-y-1 active:shadow-cta-pressed focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-brand sm:text-2xl" data-id="element-30" data-mp="2tyl0apsnqxvo">
        <span data-id="element-31" data-mp="38m61uf9vwp1h">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={3} aria-hidden="true" data-id="element-32" data-mp="1996a8vutjn9r" />
      </a>
      {note && <p className={`text-center text-sm font-medium ${tone === "dark" ? "text-white/70" : "text-ink-muted"}`} data-id="element-33" data-mp="1i8jk3pmuudv0">
          {note}
        </p>}
    </div>;
}